import { EAddToCartChildEye, ICartItem } from '../../../../container/cart/ICart';
import { DateFormat, getDaysDifferenceFromToday, getFormatedDateAsString, isDateValid } from '../../../../utils/dateUtils';
import { safeGet } from '../../../../utils/objectUtils';
import { ILineItem } from '../cartInterface';
import { Attributes, ChildItemOrder } from '../constants';
import { formatPrice } from '../reshapeCartData';
import { ProductTypes } from './../constants';

export const reshapeFrameData = (item: ILineItem, lineItems: ILineItem[]) => {
  const frame = {} as ICartItem;
  frame.id = item.id;
  frame.productId = item.productId;
  frame.qty = item.quantity || 0;
  frame.variantId = safeGet(item,'variant.id','');
  frame.sku = safeGet(item,'variant.sku','');
  frame.type = ProductTypes.FRAME;
  frame.childrenLineItems = [];
  const isAvailable = safeGet(item, 'variant.attributes', []).find((attr: any) => attr.name == Attributes.IS_AVAILABLE)?.value || '';
  frame.isAvailable = isAvailable;
  frame.isPriceValid = item.isPriceValid;

  let lensWizardData = safeGet(item, 'custom.fields.lensWizard', '{}');
  frame.additionalParams = {
    eyeglasses: {
      lensWizard: lensWizardData,
      pd: safeGet(item, 'custom.fields.pd', ''),
    },
  };
  check_obj: while (lensWizardData && typeof lensWizardData === 'string') {
    lensWizardData = JSON.parse(lensWizardData);
    if (typeof lensWizardData === 'string') continue check_obj;
    break;
  }
  frame.title = `${safeGet(lensWizardData, 'summary.frame.brand', '')} ${safeGet(lensWizardData, 'summary.frame.style', '')}`
  let rxExpirationDate = safeGet(lensWizardData, 'targetRx.expirationDate', '');
  rxExpirationDate = rxExpirationDate ? new Date(rxExpirationDate) : new Date();
  if (isDateValid(rxExpirationDate)) {
    rxExpirationDate = getFormatedDateAsString(rxExpirationDate, '-', DateFormat.YYYYMMDD);
    const daysLeftToExpireRX = getDaysDifferenceFromToday(rxExpirationDate);
    frame.isRXValid = daysLeftToExpireRX > -1;
  } else {
    frame.isRXValid = false;
  }

  const prescritionID = safeGet(lensWizardData, 'targetRx.prescriptionId', '');
  frame.prescriptionId = prescritionID;
  const iswebEnabled = safeGet(item, 'variant.attributes', []).find((attr: any) => attr.name == Attributes.WEB_ENABLED)?.value || '';
  frame.iswebEnabled = iswebEnabled;
  const summaryItems = safeGet(lensWizardData, 'summary.summaryItems', []);
  summaryItems.forEach((x: any, index: number) => {
    const title = x.category;
    const price = `${x.price}`;
    let details = '';
    // TODO: Handle multiple labels show case
    if (x?.labels?.length) {
      (x?.labels || []).forEach((y: any) => {
        details = y.name;
        if (y.detail) {
          details += ` (${y.detail})`;
        }
      })
    }
    // TODO: Add availability for each children
    (frame.childrenLineItems as any)[index] = {
      key: title,
      lineItems: [
        {
          price: price,
          description: details,
        },
      ],
      sku: item.variant.sku,
      id: item.id,
      order: ChildItemOrder.COLOR,
      // isAvailable: isAvailable
    };
  });

  frame.image = {
    src: safeGet(lensWizardData, 'summary.frame.image', ''),
    alt: frame.title,
  };
  frame.additionalParams.childrenSKUs = (lineItems || []).map(child => {
    const parentLineItemId = safeGet(child, 'custom.fields.parentLineItemId', '');
    if (child && frame.id == parentLineItemId) {
      return {
        id: child.id,
        eye: EAddToCartChildEye.both,
        sku: safeGet(child, 'variant.sku', item.variant.sku),
        quantity: child.quantity
      }
    }
  }) as any[];
  frame.additionalParams.childrenSKUs = frame.additionalParams.childrenSKUs.filter(x => !!x);
  return frame;
};


// Add protection plan as child line item to 
export const mapProtectionPlanToFrame = (frame: ICartItem, lineItems: ILineItem[]) => {
  if (!frame) {
    return null;
  }
  const savingPlanLineItems = getSavingPlansFromLineItems(lineItems);
  const mappedFrame = { ...frame };
  savingPlanLineItems.forEach(item => {
    // If parent Line Item matching with the savings/ protection plan then add it to child line items
    const parentLineItemId = safeGet(item, 'custom.fields.parentLineItemId', '');
    if (parentLineItemId === frame.id) {
      let price = safeGet(item, 'totalPrice.centAmount', '')
      if (price) {
        price = formatPrice(price / 100);
      }
      const variantAttributes = safeGet(item, 'variant.attributes', [])
      const planCode = variantAttributes.find((attr: any) => attr.name == Attributes.ITEM_REFERENCE)?.value || '';
      const isAvailable = variantAttributes.find((attr: any) => attr.name == Attributes.IS_AVAILABLE)?.value || '';
      (mappedFrame.childrenLineItems as any)[(mappedFrame.childrenLineItems as any)?.length] = {
        key: ProductTypes.SAVINGS_PLAN,
        lineItems: [
          {
            price: price,
            description: '',
          },
        ],
        sku: item.variant.sku,
        id: item.id,
        order: ChildItemOrder.COLOR,
        planCode: planCode,
        isAvailable: isAvailable
      };
      return mappedFrame;
    }
  });
  return mappedFrame;

}

export const updateCartItems = (cartItems: ICartItem[]) => {
  let resultedCartItems = cartItems;
  const savingPlans = getSavingPlansFromCartItems(cartItems);
  const frameCartItems = getFramesFromCartItems(cartItems);
  savingPlans.forEach(x => {
    const isPlanAddedToCart = isProtectionPlanAddedToFrame(frameCartItems, x.id);
    if (isPlanAddedToCart) {
      resultedCartItems = deleteSavingPlanFromCartItems(resultedCartItems, x.id);
    }
  });

  return resultedCartItems;
}

//**************************************** Helpers *****************************************/

const isProtectionPlanAddedToFrame = (frameCartItems: ICartItem[], protectionPlanId: string) => {
  const protectionPlanAdded = frameCartItems?.find(x => {
    return x.childrenLineItems?.find(x => x.id === protectionPlanId
    )
  });

  return !!protectionPlanAdded;
}

const deleteSavingPlanFromCartItems = (cartItems: ICartItem[], protectionPlanId: string) => {
  return cartItems.filter(x => x.id !== protectionPlanId);
}

const getSavingPlansFromCartItems = (items: ICartItem[]) => items?.filter(x => x.type === ProductTypes.SAVINGS_PLAN);

const getSavingPlansFromLineItems = (items: ILineItem[]) => items?.filter(x => safeGet(x, 'productType.obj.key', '') === ProductTypes.SAVINGS_PLAN);

const getFramesFromCartItems = (items: ICartItem[]) => items?.filter(x => x.type === ProductTypes.FRAME);
